import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Popover as CompassPopover } from "@circleco/compass/components/Popover";
import { useLocation } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { t } from "@/i18n-js/instance";
import { ConnectPopoverContext } from "@/react/components/shared/Connect/ConnectPopoverContext";
import { useConnectButtonCount } from "@/react/components/shared/Connect/useConnectButtonCount";
import { useIsConnectEnabled } from "@/react/hooks/useIsConnectEnabled";

import { HeaderIconButton } from "../HeaderIconButton";
import { formatNotificationsCount } from "../utils";
import { Body } from "./Body";
import { Header } from "./Header";

const isPopoverPanel = true;

export const Connect = () => {
  const { isViewOnlyMasquerading } = usePunditUserContext();
  const isConnectEnabled = useIsConnectEnabled();
  const { count } = useConnectButtonCount();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(
      location.hash === "connections" ||
        window.location.hash === "#connections",
    );
  }, [location.hash, location.pathname]);

  if (!isConnectEnabled) return null;

  return (
    <CompassPopover
      trigger={
        <HeaderIconButton
          icon="people-sparkle"
          ariaLabel={t("header_v3.connect.title")}
          hotkey="alt+c"
          counter={count > 0 ? formatNotificationsCount(count) : undefined}
          isOpen={isOpen}
          data-testid="connect-panel-button"
        />
      }
      open={isOpen}
      onOpenChange={setIsOpen}
      side="bottom"
      align="end"
      sideOffset={4}
      fillAvailableHeight
      className={classNames(
        "size-full max-h-[37rem] min-h-[37rem] max-w-[30rem] min-w-[30rem] p-0",
        {
          "cursor-not-allowed": isViewOnlyMasquerading,
        },
      )}
      data-testid="connect-panel-container"
    >
      <ConnectPopoverContext.Provider value={isPopoverPanel}>
        <div
          className={classNames("size-full overflow-hidden rounded-md", {
            "pointer-events-none": isViewOnlyMasquerading,
          })}
        >
          <Header onClose={() => setIsOpen(false)} />
          <Body onClose={() => setIsOpen(false)} />
        </div>
      </ConnectPopoverContext.Provider>
    </CompassPopover>
  );
};
